import { Link } from "react-router-dom";

export const Logo = ({ className = "" }) => (
  <Link to="/" data-testid="header-logo-link" aria-label="NE Tool Repair home" className={`flex items-center gap-3 ${className}`}>
    <img src="/brand/ne-logo-mark.png" alt="NE Tool Repair logo" width="1075" height="570" className="h-8 w-auto mix-blend-lighten" />
    <span className="font-display font-extrabold uppercase tracking-[0.12em] text-[15px] leading-none hidden sm:block">
      NE Tool <span className="text-[var(--red)]">Repair</span>
    </span>
  </Link>
);
